import React from "react";
import "./RangeSlider.sass";

/**
 * Thin orange track with a square thumb, driven by a hidden native range input.
 *
 * @param {object} props
 * @param {number} props.value
 * @param {number} props.min
 * @param {number} props.max
 * @param {number} [props.step]
 * @param {(value: number) => void} props.onChange
 * @param {string} props.label accessible name
 * @param {"start"|"center"} [props.fillFrom] center: fill grows both ways from the middle
 * @param {"accent"|"up"|"down"} [props.tone]
 * @param {(position: number) => React.ReactNode} [props.renderOverlay] e.g. a value bubble
 */
export const RangeSlider = ({
  value,
  min,
  max,
  step = 1,
  onChange,
  label,
  fillFrom = "start",
  tone = "accent",
  renderOverlay,
}) => {
  const position = max > min ? ((value - min) / (max - min)) * 100 : 0;
  const origin = fillFrom === "center" ? 50 : 0;
  const fillStyle = {
    left: `${Math.min(origin, position)}%`,
    width: `${Math.abs(position - origin)}%`,
  };

  return (
    <div className={`range-slider range-slider--${tone}`}>
      {/* First, so the focus ring selector can reach the thumb */}
      <input
        type="range"
        className="range-slider__input"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        aria-label={label}
      />
      <span className="range-slider__fill" style={fillStyle} />
      <span className="range-slider__thumb" style={{ left: `${position}%` }} />
      {renderOverlay?.(position)}
    </div>
  );
};
